module.exports = __webpack_public_path__ + "static/assets/1035a50e1ee63b6c81aaedc065e591c6.png";